import React, { useMemo, useRef, useState } from 'react';

import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import { getCheckTypeIcon } from 'helpers/iconsHelper';

import { Button } from 'components/FormComponents';
import { IconComponent } from 'components/Icon/IconComponent';
import { StatusPill } from 'components/Pills/StatusPills';

import { useClickOutside } from '../../hooks/click-outside';
import styles from './CreditsBalanceDetails.module.scss';

const Check = ({ icon, name, credits }) => {
  const status = useMemo(
    () => (credits < 0 ? 'success' : credits === 0 ? 'error' : 'neutral'),
    [credits],
  );
  const statusText = useMemo(
    () => (credits < 0 ? 'Unlimited' : credits === 0 ? 'Run out' : `${credits} left`),
    [credits],
  );
  return (
    <div className={styles.checkRow}>
      <div className="u-flex-box u-flex-align-center u-gap-small u-width-75">
        <IconComponent icon={icon} noBackground />
        <span className={cn(styles.checkRowName, 'primary-text')}>{name}</span>
      </div>
      <StatusPill text={statusText} status={status} small />
    </div>
  );
};

export const CreditsBalanceDetails = ({ companyChecks }) => {
  const wrapperRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);

  useClickOutside(wrapperRef, () => {
    setShowMenu(false);
  });

  return (
    <div className={styles.root} ref={wrapperRef}>
      <Button className={styles.button} noUppercase onClick={() => setShowMenu(!showMenu)}>
        Balance <FeatherIcon className={styles.chevron} icon="chevron-down" />
      </Button>

      {showMenu && (
        <div className={styles.dropdownMenu}>
          {companyChecks
            .filter(companyCheck => !companyCheck.archived)
            .map(companyCheck => {
              return (
                <Check
                  key={companyCheck.type}
                  icon={getCheckTypeIcon(companyCheck?.check_type?.slug)}
                  name={companyCheck.check_type.title}
                  credits={companyCheck.credits}
                />
              );
            })}

          <Button
            noUppercase
            small
            className="u-width-100 u-margin-top u-margin-bottom--small"
            onClick={() => window.open('https://www.checkmate.tech/company/contact', '_blank')}>
            Order more checks
          </Button>
        </div>
      )}
    </div>
  );
};
